export default {
    namespaced: true,
    state: {
        vtx_checkboxes: []
    },
    getters: {},
    mutations: {
        setVTXCheckBoxes(state, ids) {
            state.vtx_checkboxes = ids;
        },
        clearVTXCheckBoxes(state) {
            state.vtx_checkboxes = [];
        }
    },
    actions: {
        clearVTXCheckBoxes({ commit }) {
            commit('clearVTXCheckBoxes');
        },
        setVTXCheckBoxes({ commit }, ids) {
            commit('setVTXCheckBoxes', ids);
        },
    },
}